import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import Hero from './Hero'
import logo from '../assets/ejazul_bhai.jpg';
import Services from './Services';
import ClientCarousel from './ClientCarousel';
import Work from './Work';
import Footer from './Footer';
import MoreImages from './MoreImages';
import GlassImges from './GlassImages';
import PptCarousel from './PptCarousel';
import Certificate from './Certificate';
import ContactUs from './ContactUs';
import Map from './Map';
import AndroidApp from './AndroidApp';
import Card01 from '../Cards/Card01';
import { useNavigate } from "react-router-dom";
import Loader from './Loader';
import ScrollLogoText from './ScrollLogoText ';
import DesignEngineering from './DesignEngineering';

const Home = () => {

    const navigate = useNavigate();

    const [showMore, setShowMore] = useState(false);
    
        const handleReadMore = () => {
            setShowMore(!showMore);
        };

    const [loading, setLoading] = useState(false);

    useEffect(() =>{
        setLoading(true);
        setTimeout(()=>{
            setLoading(false);
        },3000);
    },[])

    return (
        <div >

            {
                loading?<Loader />:  <>
            
            
            {/* <Navbar /> */}
            
            <Hero />

            <ScrollLogoText />

            <div className="container 2xl:px-20 mx-auto my-10">
                            <div className="items-center text-center my-5">
                                <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-2">
                                    About Me!
                                </h1>
                            </div>
                            <div className="flex flex-col md:flex-row items-center md:items-start gap-5">
                                {/* Image Section */}
                                <div className="basis-2/5 w-full flex justify-center">
                                    <img
                                        src={logo}
                                        alt="Ejazul Haque"
                                        className="w-4/5 md:w-80 rounded-xl shadow-lg"
                                    />
                                </div>
            
                                {/* Text Section */}
                                <div className="basis-3/5 w-full px-5 md:px-10 lg:px-20">
                                    <h1 className="font-bold text-lg md:text-xl text-blue-800 mb-4">
                                        Powergenic Engineering & Technical Expertise
                                    </h1>
            
                                    <p className="text-gray-900 leading-relaxed mb-4">
                                        Welcome to Powergenic Engineering & Technical Expertise. As you
                                        navigate our website, I hope you learn more about the qualities that
                                        make our company an outstanding provider of essential government
                                        services and a wonderful place to build a career. We provide service
                                        with a human touch. We have earned the trust and respect of
                                        government customers for one simple reason: we have great people.
                                        They are experts in their fields, bring a strong service ethos to
                                        everything they do, and take pride and ownership in the jobs they do.
                                        We bring passion, pride, and experience together.
                                        <span id="dots">{!showMore && '...'}</span>
                                    </p>
            
                                    {showMore && (
                                        <div id="more">
                                            <p>
                                                We make a positive difference in people’s lives. At
                                                Powergenic, we have earned a reputation for helping our
                                                clients to transform the way in which citizens access
                                                government & pvt ltd services. The programs we support are
                                                critical to keeping the nation secure, as well as making
                                                government & pvt ltd services more efficient. From
                                                modernizing the Navy and supporting returning warriors to
                                                ensuring healthcare access and keeping the skies safe,
                                                Powergenic Engineering has earned a reputation for delivering
                                                on programs that truly make a difference. We have a client
                                                first philosophy.
                                            </p>
                                            <p>
                                                We have only one objective: to ensure our clients mission
                                                objectives are achieved with the highest level of capability
                                                and assurance, and at the lowest possible cost. Our
                                                methodology ensures that vital government programs are stood
                                                up on time and on schedule. Powergenic Engineering’s clients
                                                come to us with confidence that we have the expertise to take
                                                service delivery to the next level of performance. We have
                                                true international reach.
                                            </p>
                                            <p>
                                                We have worked in many of the most demanding and secure
                                                environments in the world, and our global reach means that we
                                                can support our clients wherever their needs require. As part
                                                of Powergenic Engineering Group plc, we are able to draw upon
                                                the accumulated knowledge of an organization that has set new
                                                standards of excellence in sectors including transportation,
                                                healthcare, and defense. We apply the very best international
                                                insights to keep our clients at the leading edge. We live out
                                                our values.
                                            </p>
                                        </div>
                                    )}
            
                                    <div className="flex justify-center">
                                        <button
                                            onClick={handleReadMore}
                                            className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-500 text-lg font-medium my-5"
                                            id="btn"
                                        >
                                            {showMore ? 'Read Less' : 'Read More'}
                                        </button>
                                    </div>
            
                                    <p className="text-gray-700 leading-relaxed">
                                        <strong>Ejazul Haque</strong> <br />
                                        Chief Executive Officer <br />
                                        Powergenic Engineering <br />
                                        Vadodara, Gujarat, India
                                    </p>
                                    <div className="flex flex-row gap-4 font-medium mt-4">
                                        <a
                                            className="text-4xl shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300 rounded-full text-blue-700 hover:text-purple-800"
                                            href="#"
                                        >
                                            <ion-icon name="logo-chrome"></ion-icon>
                                        </a>
                                        <a
                                            className="text-4xl shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300 text-blue-700 hover:text-purple-800"
                                            href="#"
                                        >
                                            <ion-icon name="logo-linkedin"></ion-icon>
                                        </a>
                                        <a
                                            className="text-4xl shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300 rounded-full text-blue-700 hover:text-purple-800"
                                            href="#"
                                        >
                                            <ion-icon name="logo-facebook"></ion-icon>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

            <Services />  

            <ClientCarousel /> 

            <Work />  

            <GlassImges />

           <PptCarousel />

           <Certificate />

           <DesignEngineering />

           <ContactUs />


           <AndroidApp />

           







            {/* <Footer />        */}

            </>}

        </div>
    )
}

export default Home





